import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { radius, themeMode, fontWeight, spacing, palette, color } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';

const getSwitchSizeMultiplier = (size) => {
  switch (size) {
    case "sm":
      return 1;
    case "md":
      return 1.5;
    case "lg":
      return 2.25;
    default:
      return 1.5;
  }
};
const factor = {
  big: 32,
  small: 16,
  tiny: 2
};
const ComponentWrapper = styled(Box).attrs(() => ({ as: "label" }))`
    position: relative;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    cursor: pointer;
`;
const InnerSwitch = styled(Box)`
    position: relative;
    width: ${({ size }) => `${factor.big * getSwitchSizeMultiplier(size)}px`};
    height: ${({ size }) => `${factor.small * getSwitchSizeMultiplier(size)}px`};
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    border-radius: ${radius("round")};
    background-color: ${themeMode({ light: palette("neutral.400"), dark: palette("neutral.700") })};
    transition: 0.2s;

    &:hover {
        background-color: ${themeMode({ light: palette("neutral.400"), dark: palette("neutral.700") })};
        transition: 0s;
    }
`;
const Handle = styled(Box)`
    display: block;
    position: absolute;
    width: ${({ size }) => `${factor.small * getSwitchSizeMultiplier(size)}px`};
    height: ${({ size }) => `${factor.small * getSwitchSizeMultiplier(size)}px`};
    transition: 0.2s;
    left: 0;
    top: 0;
    padding: ${({ size }) => `${factor.tiny * getSwitchSizeMultiplier(size)}px`};

    &:before {
        content: '';
        display: block;
        height: 100%;
        width: 100%;
        border-radius: ${radius("round")};
        background-color: ${({ isDisabled }) => isDisabled ? themeMode({ light: palette("neutral.200"), dark: palette("neutral.500") }) : themeMode({ light: palette("neutral.0"), dark: palette("neutral.0") })};
    }
`;
const OuterSwitch = styled(Box)`
    border-radius: ${radius("round")};

    input[type='checkbox']:focus ~ &&,
    input[type='checkbox']:focus-visible ~ && {
        box-shadow: ${themeMode({ dark: color("neutral.50"), light: color("neutral.900") })} 0px 0px 0px
            ${factor.tiny}px;
    }

    input[type='checkbox']:focus:not(:focus-visible) ~ && {
        box-shadow: none;
    }

    input[type='checkbox']:checked ~ && {
        & > ${InnerSwitch} {
            background-color: ${({ isDisabled }) => isDisabled ? themeMode({ light: palette("neutral.400"), dark: palette("neutral.700") }) : themeMode({ light: palette("primary.500"), dark: palette("primary.500") })};
            transition: 0.2s;

            &:hover {
                background-color: ${({ isDisabled }) => isDisabled ? themeMode({ light: palette("neutral.400"), dark: palette("neutral.700") }) : themeMode({ light: palette("primary.500"), dark: palette("primary.500") })};
                transition: 0s;
            }
        }
    }

    input[type='checkbox']:checked ~ && {
        & ${Handle} {
            left: ${({ size }) => `calc(100% - ${factor.small * getSwitchSizeMultiplier(size)}px)`};
        }
    }
`;
const OffLabel = styled(Box)`
    font-weight: ${fontWeight("bold")};
    margin-right: ${({ size }) => size === "lg" ? spacing("md") : spacing("xs")};
`;
const OnLabel = styled(Box)`
    font-weight: ${fontWeight("bold")};
    margin-left: ${({ size }) => size === "lg" ? spacing("md") : spacing("xs")};
`;
const Styled = {
  ComponentWrapper,
  OuterSwitch,
  InnerSwitch,
  OffLabel,
  OnLabel,
  Handle
};

export { Styled, getSwitchSizeMultiplier };
//# sourceMappingURL=styled.es.js.map
